function InputTable({inputData, handleChange, modelData}) {

  return (
    <form className="form">
      <table className="mb-table">
        <tbody>
          <tr>
            <td>
              <label htmlFor="p1">How much do you weigh? [kg]</label>
              <input
                id="p1"
                name="p1"
                type="number"
                placeholder="70"
                min="0"
                value={inputData.p1 ? inputData.p1 : ""}
                onChange={handleChange}
              ></input>
            </td>
          </tr>
          <tr>
            <td>
              <label htmlFor="p2">What about your instructor? [kg]</label>
              <input
                id="p2"
                name="p2"
                type="number"
                placeholder="70"
                min="0"
                value={inputData.p2 ? inputData.p2 : ""}
                onChange={handleChange}
              ></input>
            </td>
          </tr>

          {!!(
            modelData.modelo.includes("172") ||
            modelData.modelo.includes("Arrow") ||
            modelData.modelo.includes("40") ||
            modelData.modelo.includes("2006")
          ) && (
            <tr>
              <td>
                <label htmlFor="rpax1">And the passengers? [kg]</label>
                <input
                  id="rpax1"
                  name="rpax1"
                  type="number"
                  placeholder="70"
                  min="0"
                  value={inputData.rpax1 ? inputData.rpax1 : ""}
                  onChange={handleChange}
                ></input>
              </td>
            </tr>
          )}

          {!!modelData.modelo.includes("SENECA") && (
            <tr>
              <td>
                <label htmlFor="rpax1">
                  And the passengers (center seats fwd facing)? [kg]
                </label>
                <input
                  id="rpax1"
                  name="rpax1"
                  type="number"
                  placeholder="70"
                  min="0"
                  value={inputData.rpax1 ? inputData.rpax1 : ""}
                  onChange={handleChange}
                ></input>
              </td>
            </tr>
          )}

          {!!modelData.modelo.includes("SENECA") && (
            <tr>
              <td>
                <label htmlFor="rpax2">
                  And the passengers (center seats aft facing)? [kg]
                </label>
                <input
                  id="rpax2"
                  name="rpax2"
                  type="number"
                  placeholder="70"
                  min="0"
                  value={inputData.rpax2 ? inputData.rpax2 : ""}
                  onChange={handleChange}
                ></input>
              </td>
            </tr>
          )}

          {!!modelData.modelo.includes("SENECA") && (
            <tr>
              <td>
                <label htmlFor="rpax3">And rear passengers? [kg]</label>
                <input
                  id="rpax3"
                  name="rpax3"
                  type="number"
                  placeholder="70"
                  min="0"
                  value={inputData.rpax3 ? inputData.rpax3 : ""}
                  onChange={handleChange}
                ></input>
              </td>
            </tr>
          )}

          {!!modelData.modelo.includes("SENECA") && (
            <tr>
              <td>
                <label htmlFor="rpax4">And jumpseat passenger? [kg]</label>
                <input
                  id="rpax4"
                  name="rpax4"
                  type="number"
                  placeholder="70"
                  min="0"
                  value={inputData.rpax4 ? inputData.rpax4 : ""}
                  onChange={handleChange}
                ></input>
              </td>
            </tr>
          )}

          <tr>
            <td>
              <label htmlFor="bag1">How much does area 1 luggage weigh? [kg]</label>
              <input
                id="bag1"
                name="bag1"
                type="number"
                placeholder="7"
                min="0"
                value={inputData.bag1 ? inputData.bag1 : ""}
                onChange={handleChange}
              ></input>
            </td>
          </tr>

          {!!(
            modelData.modelo.includes("172") ||
            modelData.modelo.includes("SENECA")
          ) && (
            <tr>
              <td>
                <label htmlFor="bag2">And area 2 luggage? [kg]</label>
                <input
                  id="bag2"
                  name="bag2"
                  type="number"
                  placeholder="7"
                  min="0"
                  value={inputData.bag2 ? inputData.bag2 : ""}
                  onChange={handleChange}
                ></input>
              </td>
            </tr>
          )}

          <tr>
            <td>
              <label htmlFor="fob">How much fuel are you carrying? [USG]</label>
              <input
                id="fob"
                name="fob"
                type="number"
                placeholder="30"
                min="0"
                value={inputData.fob ? inputData.fob : ""}
                onChange={handleChange}
              ></input>
            </td>
          </tr>

          {!!(
            modelData.modelo.includes("172") ||
            modelData.modelo.includes("SENECA") ||
            modelData.modelo.includes("P-")
          ) && (
            <tr>
              <td>
                <label htmlFor="tf">How much is your Trip Fuel? [USG]</label>
                <input
                  id="tf"
                  name="tf"
                  type="number"
                  placeholder="11"
                  min="0"
                  value={inputData.tf ? inputData.tf : ""}
                  onChange={handleChange}
                ></input>
              </td>
            </tr>
          )}
          {!!modelData.modelo.includes("172") && (
            <tr>
              <td>
                <label htmlFor="DEPElev">
                  Departure elevation? [ft]
                </label>
                <input
                  id="DEPElev"
                  name="DEPElev"
                  type="number"
                  min="0"
                  placeholder="2269"
                  value={inputData.DEPElev ? inputData.DEPElev : ""}
                  onChange={handleChange}
                ></input>
              </td>
            </tr>
          )}
          {!!modelData.modelo.includes("172") && (
            <tr>
              <td>
                <label htmlFor="ARRElev">Arrival elevation? [ft]</label>
                <input
                  id="ARRElev"
                  name="ARRElev"
                  type="number"
                  placeholder="2269"
                  value={inputData.ARRElev ? inputData.ARRElev : ""}
                  onChange={handleChange}
                ></input>
              </td>
            </tr>
          )}
          {!!modelData.modelo.includes("172") && (
            <tr>
              <td>
                <label htmlFor="DEPTemp">
                  Departure temperature? [ºC]
                </label>
                <input
                  id="DEPTemp"
                  name="DEPTemp"
                  type="number"
                  placeholder="15"
                  value={inputData.DEPTemp ? inputData.DEPTemp : ""}
                  onChange={handleChange}
                ></input>
              </td>
            </tr>
          )}
          {!!modelData.modelo.includes("172") && (
            <tr>
              <td>
                <label htmlFor="ARRTemp">Arrival temperature? [ºC]</label>
                <input
                  id="ARRTemp"
                  name="ARRTemp"
                  type="number"
                  placeholder="15"
                  value={inputData.ARRTemp ? inputData.ARRTemp : ""}
                  onChange={handleChange}
                ></input>
              </td>
            </tr>
          )}
          {!!modelData.modelo.includes("172") && (
            <tr>
              <td>
                <label htmlFor="DEPQNH">
                  Departure QNH? [hPa]
                </label>
                <input
                  id="DEPQNH"
                  name="DEPQNH"
                  type="number"
                  placeholder="1013"
                  value={inputData.DEPQNH ? inputData.DEPQNH : ""}
                  onChange={handleChange}
                ></input>
              </td>
            </tr>
          )}
          {!!modelData.modelo.includes("172") && (
            <tr>
              <td>
                <label htmlFor="ARRQNH">Arrival QNH? [hPa]</label>
                <input
                  id="ARRQNH"
                  name="ARRQNH"
                  type="number"
                  placeholder="1013"
                  value={inputData.ARRQNH ? inputData.ARRQNH : ""}
                  onChange={handleChange}
                ></input>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </form>
  );

};

export default InputTable;